
export default function TallPanel({styles}) {
    return (
    <svg width="550" height="1195" viewBox="0 0 550 1195" fill="none" xmlns="http://www.w3.org/2000/svg"
         className={styles} preserveAspectRatio={"none"}>
    <path
            d="M0.5 1190V101.138C0.5 99.9088 1.00247 98.7335 1.89077 97.8845L102.477 1.7469C103.314 0.946613 104.428 0.5 105.586 0.5H545C547.485 0.5 549.5 2.51472 549.5 5V1126.21C549.5 1127.77 548.691 1129.22 547.362 1130.04L443.931 1193.83C443.221 1194.27 442.403 1194.5 441.569 1194.5H5C2.51472 1194.5 0.5 1192.49 0.5 1190Z"
            fill="#92AFAE" stroke="#7991C4"/>
    </svg>

    )
}